module.exports = __webpack_public_path__ + "static/media/business.c8d32772.svg";